import { Calendar } from 'lucide-react'

interface TimePeriodSelectorProps {
  value: string
  onChange: (period: string) => void
}

function getMelbourneQuarter() {
  const now = new Date()
  const month = parseInt(new Intl.DateTimeFormat('en-AU', { timeZone: 'Australia/Melbourne', month: 'numeric' }).format(now))
  const year = parseInt(new Intl.DateTimeFormat('en-AU', { timeZone: 'Australia/Melbourne', year: 'numeric' }).format(now))
  const q = Math.ceil(month / 3)
  return { q, year }
}

function getTimePeriods() {
  const { q, year } = getMelbourneQuarter()
  const lastQ = q - 1 < 1 ? 4 : q - 1
  const lastQYear = q - 1 < 1 ? year - 1 : year

  return [
    { value: 'current_quarter', label: `Current Quarter (Q${q} ${year})` },
    { value: 'last_quarter', label: `Last Quarter (Q${lastQ} ${lastQYear})` },
    { value: 'last_90_days', label: 'Last 90 Days' },
    { value: 'last_6_months', label: 'Last 6 Months' },
    { value: 'ytd', label: `Year to Date (${year})` },
    { value: 'all_time', label: 'All Time' },
  ]
}

export const TIME_PERIODS = getTimePeriods()

export function TimePeriodSelector({ value, onChange }: TimePeriodSelectorProps) {
  return (
    <div className="flex items-center gap-2">
      <Calendar className="h-4 w-4 text-[var(--text-muted)]" />
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="
          px-3 py-2 rounded-lg text-sm
          bg-[var(--bg-secondary)] text-[var(--text-primary)]
          border border-[var(--border-color)]
          hover:border-[var(--text-muted)] transition-colors
          focus:outline-none focus:ring-2 focus:ring-[var(--button-primary-bg)]
        "
      >
        {TIME_PERIODS.map((period) => (
          <option key={period.value} value={period.value}>
            {period.label}
          </option>
        ))}
      </select>
    </div>
  )
}
